export enum StoragePathAliasType {
  Main = "Main",
  Secondary = "Secondary",
  Gateway = "Gateway",
  Mac = "Mac",
  Diva = "Diva",
  RemoteIngest = "RemoteIngest",
  AsperaEnterpriseServer = "AsperaEnterpriseServer",
}
